import React from 'react';
import { ApiDocumentation } from '@/types/api';

interface HeaderProps {
  documentation: ApiDocumentation;
}

/**
 * Header component displaying documentation title and metadata with Freespace logo
 */
export const Header: React.FC<HeaderProps> = ({ documentation }) => {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="px-8 py-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">
              API Documentation
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              Manage and explore all API endpoints across collections
            </p>
          </div>
          
          <div className="flex items-center space-x-4">
            {documentation.version && (
              <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-600">Version:</span>
                <span className="bg-emerald-100 text-emerald-800 px-2 py-1 rounded text-sm font-medium">
                  {documentation.version}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

